<div class="bg-surface-100 flex gap-2 rounded-md p-2 select-none">
  <ng-content />
</div>
